import requestApi from "@/utils/requestApi";

export default {
  data() {
    return {
      id: "",
      searchForm: {
        name: "",
      },
      list: [],
      loading: false,
      originList: [],
      visible: false,

      total: 0,
      pageNum: 1,
      pageSize: 30,
      pageCount: 1,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const { data = [] } = await requestApi.post("sctrading/shop/selShopList", this.searchForm);
      this.loading = false;

      this.originList = data;
      this.total = data.length;

      this.pageSet();
    },
    // 显示
    open() {
      this.visible = true;
    },
    // 页码设置
    pageSet() {
      const { pageNum, pageSize, originList } = this;
      this.list = originList.slice(parseInt((pageNum - 1) * pageSize), parseInt(pageSize * pageNum));
      this.pageCount = Math.ceil(originList.length / pageSize);
    },
    // 重置搜索
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageNum = 1;
      this.pageSize = pageSize;
      this.pageSet();
    },
    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.pageSet();
    },
    // 选择
    rowClick(row) {
      this.id = row.shopId;
    },
    // 取消
    cancel() {
      this.id = "";
      this.visible = false;
    },
    // 确定
    confirm() {
      if (this.id) {
        this.$emit("confirm", this.id);
        this.id = "";
        this.visible = false;
      } else {
        this.$message.warning("请选择供应商");
      }
    },
  },
};
